module.exports = __webpack_public_path__ + "static/media/rain_light.ff50ca0d.svg";